module.exports = "/images/vendor/@milestoneslabs/milestones-ui-kit/src/static/project-illustrations/homeImprovement.svg?ad9ccf80dbc6becdf524bc23e2e739bb";